import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ModalPassword from "../modal-password/component";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import {cartRegister} from "../../services/cartRegister";
import ModalProfileImageSize from "../modal-profileimagesize/component";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {imagesRegister} from "../../services/imagesRegister";
import {agentRegister} from "../../services/agentRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            account: {},
            edit_profile: false,
            edit_password: false,
            edit_email: false,
            edit_lead: false,
            email_pref: null,
            lead_pref: null,
            fallback_pref: null,
            modal: false,
            profile_image: null,
            logo_image: null,
            email: "",
            first_name: "",
            last_name: "",
            old_password: "",
            password: "",
            confirm_password: "",
            isLoading: true,
            error: false,
            edit_branding: false,
            branding_pref: null,
            branding_image: null,
            favicon_image: null
        };
        this._setModal = this._setModal.bind(this);
    };

    componentWillMount() {
        this._updateData();
        this._updateUser();
    }

    _updateUser() {
        let user = userRegister.get();
        try {
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse
            }, () => {
                //FACEBOOK PIXEL
                if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                    ReactPixel.pageView();
                }
                if (this.state.inhouse) {
                    //GOOGLE ANALYTICS
                    if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactGA.pageview('/user/profile/admin');
                        ReactGA4.send({ hitType: "pageview", page: "/user/profile/admin" });
                    }
                } else {
                    if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactGA.pageview('/user/profile');
                        ReactGA4.send({ hitType: "pageview", page: "/user/profile" });
                    }
                }
            });
        } catch (e) {
        }
        if (user.socialData) {
            this.setState({
                branding: user.socialData.branding ? user.socialData.branding : false,
                instagram_id: user.socialData.instagramID ? user.socialData.instagramID : '',
                facebook_id: user.socialData.facebookID ? user.socialData.facebookID : '',
                tiktok_id: user.socialData.tiktokID ? user.socialData.tiktokID : '',
                snapchat_id: user.socialData.snapchatID ? user.socialData.snapchatID : '',
            });
        }
    }

    validators = {
        email: (value) => {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        },
        website: (value) => {
            try {
                return value.length > 2
            } catch (e) {
                return false
            }
        },
        phone: (value) => {
            var re = /^[0-9 +]+$/;
            return re.test(String(value).toLowerCase()) && value.length > 5;
        }
    };

    functions = {
        addCroppedLogo: () => {
            let item = this.refs.cropper.getCroppedCanvas({
                //control opacity here by changing jpg to png and comment out background fill
                //fillColor: '#fff'
            }).toDataURL('image/png');
            let image_file = this.functions.dataURItoBlob(item);
            const formData = new FormData();
            formData.append("logo", image_file);
            this.setState({
                src: null
            }, () => {
                dataRegister.postLogoImage(salesChannelRegister.get("market"), formData).then((response) => {
                    if (response.link) {
                        this.state.account.logo_image = response.link;
                        this.setState({
                            account: this.state.account
                        }, () => {
                            let user = userRegister.get();
                            user.logo_image = response.link;
                            userRegister.set(user);
                        });
                    }
                }, (error) => {
                    console.log(error);
                });
            })
        },
        addCroppedBranding: () => {
            let item = this.refs.cropper.getCroppedCanvas({
                fillColor: '#fff'
            }).toDataURL('image/jpeg');
            let image_file = this.functions.dataURItoBlob(item);
            const formData = new FormData();
            formData.append("branding", image_file);
            this.setState({
                src: null
            }, () => {
                dataRegister.postBrandingImage(salesChannelRegister.get("market"), formData).then((response) => {
                    if (response.link) {
                        this.state.account.branding_image = response.link;
                        this.setState({
                            account: this.state.account
                        }, () => {
                            let user = userRegister.get();
                            user.branding_image = response.link;
                            userRegister.set(user);
                        });
                    }
                }, (error) => {
                    console.log(error);
                });
            })
        },
        addCroppedFavicon: () => {
            let item = this.refs.cropper.getCroppedCanvas({
                //control opacity here by changing jpg to png and comment out background fill
                //fillColor: '#fff'
            }).toDataURL('image/png');
            let image_file = this.functions.dataURItoBlob(item);
            const formData = new FormData();
            formData.append("favicon", image_file);
            this.setState({
                src: null
            }, () => {
                dataRegister.postBrandingFaviconImage(salesChannelRegister.get("market"), formData).then((response) => {
                    if (response.link) {
                        this.state.account.favicon_image = response.link;
                        this.setState({
                            account: this.state.account
                        }, () => {
                            let user = userRegister.get();
                            user.favicon_image = response.link;
                            userRegister.set(user);
                        });
                    }
                }, (error) => {
                    console.log(error);
                });
            })
        },
        dataURItoBlob: (dataURI) => {
            try {
                var byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                    byteString = atob(dataURI.split(',')[1]);
                } else {
                    byteString = unescape(dataURI.split(',')[1]);
                }
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ia], {type: mimeString});
            } catch (e) {
                console.log(e);
            }
        },
        dataURItoBlobPromise: (dataURI) => {
            return new Promise(function (resolve, reject) {
                try {
                    var byteString;
                    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                        byteString = atob(dataURI.split(',')[1]);
                    } else {
                        byteString = unescape(dataURI.split(',')[1]);
                    }
                    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                    var ia = new Uint8Array(byteString.length);
                    for (var i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }
                    resolve(new Blob([ia], {type: mimeString}));
                } catch (e) {
                    console.log(e);
                }
            })
        },
    };

    _updateData() {
        dataRegister.account(salesChannelRegister.get('market')).then((response) => {
            try {
                response.country = response.country.toUpperCase();
            } catch (e) {
            }
            this.setState({
                account: response,
                email_pref: response.email_pref,
                lead_pref: response.lead_pref,
                fallback_pref: response.fallback_pref,
                branding_pref: response.branding_pref,
                isLoading: false
            });
        }, (error) => {
            this.setState({isLoading: false, error: true})
        });
    }

    _changePassword() {
        if (this.state.edit_password && !this.state.isLoading) {
            if (this.state.old_password !== "" && this.state.password !== "" && this.state.confirm_password !== "" && this.state.password === this.state.confirm_password) {
                this.setState({isLoading: true});
                let data = {
                    new_password: this.state.password,
                    new_password_confirm: this.state.confirm_password,
                    old_password: this.state.old_password
                };
                dataRegister.resetPasswordToken(salesChannelRegister.get('market'), data).then((response) => {
                    this.setState({
                        isLoading: false,
                        password: "",
                        old_password: "",
                        confirm_password: "",
                        edit_password: false,
                        modal: true
                    });
                }, (error) => {
                    this.setState({isLoading: false});
                });
            } else {

            }
        }
    }

    _changeAccount() {
        if ((this.state.edit_profile || this.state.edit_email || this.state.edit_lead) && !this.state.isLoading) {
            this.setState({isLoading: true});
            this.state.account.email_pref = this.state.email_pref;
            if (this.state.account.lead_pref && !this.validators.email(this.state.account.lead_pref.excluded_email)) {
                this.state.account.lead_pref.excluded_email = "";
            }
            if (this.state.account.lead_pref && !this.validators.email(this.state.account.lead_pref.cc_email_1)) {
                this.state.account.lead_pref.cc_email_1 = "";
            }
            if (this.state.account.lead_pref && !this.validators.email(this.state.account.lead_pref.cc_email_2)) {
                this.state.account.lead_pref.cc_email_2 = "";
            }
            this.state.account.lead_pref = this.state.lead_pref;
            this.state.account.fallback_pref = this.state.fallback_pref;
            let data = {
                name: this.state.account.name,
                surname: this.state.account.surname,
                phone: this.state.account.phone,
                email_pref: this.state.email_pref,
                lead_pref: this.state.lead_pref,
                fallback_pref: this.state.fallback_pref,
                billing_company: this.state.account.billing_company,
                street: this.state.account.street,
                zipcode: this.state.account.zipcode,
                city: this.state.account.city,
                vat_no: this.state.account.vat_no

            };
            dataRegister.editAccount(salesChannelRegister.get('market'), data).then((item) => {
                this.setState({isLoading: false, edit_profile: false, edit_email: false, edit_lead: false}, () => {
                    let user = userRegister.get();
                    user.name = item.name;
                    user.surname = item.surname;
                    user.email_pref = item.email_pref;
                    user.lead_pref = item.lead_pref;
                    user.fallback_pref = item.fallback_pref;
                    user.phone = item.phone;
                    user.billing_company = item.billing_company;
                    user.street = item.street;
                    user.zipcode = item.zipcode;
                    user.city = item.city;
                    user.vat_no = item.vat_no;
                    userRegister.set(user);
                });
            }, (error) => {
                this.setState({isLoading: false, error: true})
            });
        }
    }

    _changeBranding() {
        if (this.state.edit_branding && !this.state.isLoading) {
            this.setState({isLoading: true});
            this.state.account.branding_pref = this.state.branding_pref;
            let data = {
                branding_pref: this.state.branding_pref
            };
            dataRegister.editAccount(salesChannelRegister.get('market'), data).then((item) => {
                this.setState({isLoading: false, edit_branding: false}, () => {
                    let user = userRegister.get();
                    user.branding_pref = item.branding_pref;
                    userRegister.set(user);
                });
            }, (error) => {
                this.setState({isLoading: false, error: true})
            });
        }
    }

    _changeProfileImage(e) {
        try {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                if (files[0]) {
                    if (files[0].size < 2000000) {
                        const formData = new FormData();
                        formData.append("logo", files[0]);
                        dataRegister.postProfileImage(salesChannelRegister.get("market"), formData).then((response) => {
                            if (response.link) {
                                this.state.account.profile_image = response.link;
                                this.setState({account: this.state.account}, () => {
                                    let user = userRegister.get();
                                    user.profile_image = response.link;
                                    userRegister.set(user);
                                });
                            }
                        }, (error) => {
                            console.log(error);
                        });
                    } else {
                        this.setState({
                            size_modal: true
                        })
                    }
                }
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _changeLogoImage(e) {
        try {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                if (files[0]) {
                    if (files[0].size < 2000000) {
                        const formData = new FormData();
                        files[0].width = "600";
                        files[0].height = "200";
                        formData.append("logo", files[0]);
                        //formData.append("logo_width", "600");
                        //formData.append("logo_height", "200");
                        dataRegister.postLogoImage(salesChannelRegister.get("market"), formData).then((response) => {
                            if (response.link) {
                                this.state.account.logo_image = response.link;
                                this.setState({account: this.state.account}, () => {
                                    let user = userRegister.get();
                                    user.logo_image = response.link;
                                    userRegister.set(user);
                                });
                            }
                        }, (error) => {
                            console.log(error);
                        });
                    } else {
                        this.setState({
                            size_modal: true
                        })
                    }
                }
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _setEmailPref(key) {
        if (this.state.edit_email && !this.state.isLoading) {
            this.state.email_pref[key] = !this.state.email_pref[key];
            this.setState({email_pref: this.state.email_pref});
        }
    }

    _setThemePref(key) {
        if (this.state.edit_branding && !this.state.isLoading) {
            this.state.branding_pref[key] = !this.state.branding_pref[key];
            this.setState({branding_pref: this.state.branding_pref});
        }
    }

    _setLeadPref(key) {
        if (this.state.edit_lead && !this.state.isLoading) {
            this.state.lead_pref[key] = !this.state.lead_pref[key];
            this.setState({lead_pref: this.state.lead_pref});
        }
    }

    _setFallbackPref(key) {
        if (this.state.edit_profile && !this.state.isLoading) {
            this.state.fallback_pref[key] = !this.state.fallback_pref[key];
            this.setState({fallback_pref: this.state.fallback_pref});
        }
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _setModal() {
        this.setState({modal: false});
    }

    _renderProfileImage() {
        return (
            <div className={Styles.imagesContainerItem}>
                <div className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.account.profile_image &&
                        <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                    }
                    {
                        this.state.account.profile_image &&
                        <div style={{backgroundImage: "url(" + this.state.account.profile_image + ")"}}
                             className={Styles.imagesContainerItemInnerUploadImage}/>
                    }
                    {
                        this.state.account.profile_image &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                           onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg, image/png"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.account.profile_image &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => this._changeProfileImage(e)} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                    </div>
                }
            </div>
        )
    }

    _renderLogoImage() {
        return (
            <div className={Styles.imagesContainerItemLogo}>
                <div className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.account.logo_image &&
                        <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                    }
                    {
                        this.state.account.logo_image &&
                        <div className={Styles.imagesContainerItemInnerLogoContainer}>
                            <div className={Styles.imagesContainerItemInnerLogoContainerInner}>
                                <img src={this.state.account.logo_image}
                                     className={Styles.imagesContainerItemInnerLogoContainerLogoImage}/>
                            </div>
                        </div>
                    }
                    {
                        this.state.account.logo_image &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                           onChange={(e) => {
                               if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                   if (e.target.files[0].size > 5999000) {
                                       this.setState({size_modal: true});
                                   } else {
                                       const reader = new FileReader();
                                       reader.addEventListener("load", () => {
                                           this.setState({src: reader.result});
                                       });
                                       reader.readAsDataURL(e.target.files[0]);
                                   }
                               } else {

                               }
                           }} type="file" accept="image/jpeg image/png"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.account.logo_image &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => {
                                   if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                       if (e.target.files[0].size > 5999000) {
                                           this.setState({size_modal: true});
                                       } else {
                                           const reader = new FileReader();
                                           reader.addEventListener("load", () => {
                                               this.setState({src: reader.result});
                                           });
                                           reader.readAsDataURL(e.target.files[0]);
                                       }
                                   } else {

                                   }
                               }} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                    </div>
                }
            </div>
        )
    }

    _renderBrandingImage() {
        return (
            <div style={{marginBottom: '0px'}} className={Styles.imagesContainerItemBranding}>
                <div className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.account.branding_image &&
                        <div className={Styles.imagesContainerItemInnerIconBranding}>+</div>
                    }
                    {
                        this.state.account.branding_image &&
                        <div className={Styles.imagesContainerItemInnerLogoContainer}>
                            <div className={Styles.imagesContainerItemInnerLogoContainerInner}>
                                <img src={this.state.account.branding_image}
                                     className={Styles.imagesContainerItemInnerLogoContainerImage}/>
                            </div>
                        </div>
                    }
                    {
                        this.state.account.branding_image &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    this.state.edit_branding &&
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                           onChange={(e) => {
                               if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                   if (e.target.files[0].size > 5999000) {
                                       this.setState({size_modal: true});
                                   } else {
                                       const reader = new FileReader();
                                       reader.addEventListener("load", () => {
                                           this.setState({
                                               src: reader.result,
                                               edit_brandpic: true
                                           });
                                       });
                                       reader.readAsDataURL(e.target.files[0]);
                                   }
                               } else {

                               }
                           }} type="file" accept="image/jpeg image/png"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.account.branding_image && this.state.edit_branding &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => {
                                   if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                       if (e.target.files[0].size > 5999000) {
                                           this.setState({size_modal: true});
                                       } else {
                                           const reader = new FileReader();
                                           reader.addEventListener("load", () => {
                                               this.setState({
                                                   src: reader.result,
                                                   edit_brandpic: true
                                               });
                                           });
                                           reader.readAsDataURL(e.target.files[0]);
                                       }
                                   } else {

                                   }
                               }} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                    </div>
                }
            </div>
        )
    }

    _renderBrandingFaviconImage() {
        return (
            <div style={{marginBottom: '0px'}} className={Styles.imagesContainerItemFavicon}>
                <div className={Styles.imagesContainerItemInner}>
                    {
                        !this.state.account.favicon_image &&
                        <div className={Styles.imagesContainerItemInnerIconFavicon}>+</div>
                    }
                    {
                        this.state.account.favicon_image &&
                        <div className={Styles.imagesContainerItemInnerLogoContainerFavicon}>
                            <div className={Styles.imagesContainerItemInnerLogoContainerInner}>
                                <img src={this.state.account.favicon_image}
                                     className={Styles.imagesContainerItemInnerLogoContainerImage}/>
                            </div>
                        </div>
                    }
                    {
                        this.state.account.favicon_image &&
                        <div className={Styles.imagesContainerItemLoader}>
                            <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
                {
                    this.state.edit_branding &&
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                           onChange={(e) => {
                               if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                   if (e.target.files[0].size > 5999000) {
                                       this.setState({size_modal: true});
                                   } else {
                                       const reader = new FileReader();
                                       reader.addEventListener("load", () => {
                                           this.setState({
                                               src: reader.result,
                                               edit_favicon: true
                                           });
                                       });
                                       reader.readAsDataURL(e.target.files[0]);
                                   }
                               } else {

                               }
                           }} type="file" accept="image/jpeg image/png"
                           className={Styles.imagesContainerItemInnerUpload}/>
                }
                {
                    this.state.account.favicon_image && this.state.edit_branding &&
                    <div className={Styles.imagesContainerItemInnerIconPlus}>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => {
                                   if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                                       if (e.target.files[0].size > 5999000) {
                                           this.setState({size_modal: true});
                                       } else {
                                           const reader = new FileReader();
                                           reader.addEventListener("load", () => {
                                               this.setState({
                                                   src: reader.result,
                                                   edit_favicon: true
                                               });
                                           });
                                           reader.readAsDataURL(e.target.files[0]);
                                       }
                                   } else {

                                   }
                               }} type="file" accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                        <img className={Styles.imagesContainerItemInnerIconPlusIcon}
                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                    </div>
                }
            </div>
        )
    }

    _renderText(item) {
        return langRegister.get("user-profile", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.src &&
                    <div className={Styles.overlayCopper}>
                        <div className={Styles.overlayModalCrop}>
                            {
                                <Cropper
                                    ref='cropper'
                                    modal={false}
                                    src={this.state.src}
                                    aspectRatio={this.state.edit_favicon?(1):(this.state.edit_brandpic?(76 / 25):(38 / 25))}
                                    guides={false}
                                    background={false}
                                    zoomOnWheel={!this.state.edit_favicon}
                                    fillColor={!this.state.edit_favicon?"#ffffff":null}
                                    scalable={!this.state.edit_favicon}
                                    dragMode={'none'}
                                    style={{height: 400, width: '100%'}}
                                />
                            }
                            <div className={Styles.overlayModalCropButtons}>
                                <div className={Styles.overlayModalCropButtonsInner}>
                                    <div onClick={() => {
                                        this.setState({
                                            src: null,
                                            edit_favicon: false,
                                            edit_brandpic: false
                                        })
                                    }}
                                         style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#00273A'} : {}}
                                         className={Styles.overlayModalCropButtonsItemRemove}>
                                        <img className={Styles.overlayModalCropButtonsItemRemoveIcon}
                                             src={require("../../assets/images/AB_cross_bold.png")}/>
                                    </div>
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? {backgroundColor: '#E65032'} : {}}
                                        onClick={() => {
                                            if(this.state.edit_branding){
                                                if (this.state.edit_favicon) {
                                                    this.functions.addCroppedFavicon();
                                                } else if (this.state.edit_brandpic) {
                                                    this.functions.addCroppedBranding();
                                                } else {
                                                    this.functions.addCroppedLogo();
                                                }
                                            }else{
                                                this.functions.addCroppedLogo();
                                            }
                                        }}
                                        className={Styles.overlayModalCropButtonsItemSelect}>
                                        <img className={Styles.overlayModalCropButtonsItemSelectIcon}
                                             src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                    </div>
                                    <div
                                        style={{backgroundColor: '#BFBFBF', marginLeft: "17px"}}
                                        onClick={() => {
                                            this.refs.cropper.reset();
                                        }}
                                        className={Styles.overlayModalCropButtonsItemSelect}>
                                        <img style={{width: "22px"}}
                                             src={require("../../assets/images/reset-icon.svg")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.modal &&
                    <ModalPassword setModal={this._setModal}/>
                }
                {
                    this.state.size_modal &&
                    <ModalProfileImageSize setLeave={() => {
                        this.setState({
                            size_modal: false
                        })
                    }}/>
                }
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        this.state.account && this.state.email_pref && this.state.lead_pref && !this.state.isLoading &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.contentInnerItem}>
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_24")}
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDivider}>
                                            {this._renderProfileImage()}
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_25")}
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDivider}>
                                            {this._renderLogoImage()}
                                        </div>
                                    </div>
                                }
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_2")}
                                    </div>
                                    {
                                        !this.state.edit_profile &&
                                        <div onClick={() => this.setState({edit_profile: true})}
                                             className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_profile &&
                                        <div onClick={() => this._changeAccount()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_profile &&
                                        <div onClick={() => this.setState({edit_profile: true})}
                                             className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_profile &&
                                        <div onClick={() => this._changeAccount()}
                                             className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } onChange={(event) => {
                                            this.state.account.name = event.target.value;
                                            this.setState({account: this.state.account})
                                        }} readOnly={!this.state.edit_profile} value={this.state.account.name}
                                            placeholder={this._renderText("item_10")}/>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } onChange={(event) => {
                                            this.state.account.surname = event.target.value;
                                            this.setState({account: this.state.account})
                                        }} readOnly={!this.state.edit_profile} value={this.state.account.surname}
                                            placeholder={this._renderText("item_11")}/>
                                    </div>
                                </div>
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.billing_company = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} readOnly={!this.state.edit_profile}
                                                value={this.state.account.billing_company}
                                                placeholder={this._renderText("item_17")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.street = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} readOnly={!this.state.edit_profile} value={this.state.account.street}
                                                placeholder={this._renderText("item_18")}/>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.zipcode = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} readOnly={!this.state.edit_profile} value={this.state.account.zipcode}
                                                placeholder={this._renderText("item_19")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.city = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} readOnly={!this.state.edit_profile} value={this.state.account.city}
                                                placeholder={this._renderText("item_20")}/>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.inhouse || this.state.reseller) &&
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } readOnly={true} value={this.state.account.country}
                                                placeholder={this._renderText("item_21")}/>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_profile
                                                        })
                                                } onChange={(event) => {
                                                this.state.account.vat_no = event.target.value;
                                                this.setState({account: this.state.account})
                                            }} readOnly={!this.state.edit_profile} value={this.state.account.vat_no}
                                                placeholder={this._renderText("item_22")}/>
                                        </div>
                                    </div>
                                }
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: true
                                                    })
                                            } readOnly={true} value={this.state.account.email}
                                            placeholder={this._renderText("item_12")}/>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_profile
                                                    })
                                            } onChange={(event) => {
                                            this.state.account.phone = event.target.value.trim();
                                            this.setState({account: this.state.account})
                                        }} readOnly={!this.state.edit_profile} value={this.state.account.phone}
                                            placeholder={this._renderText("item_23")}/>
                                    </div>
                                </div>
                                {
                                    this.state.branding_pref && this.state.branding_pref.primary_color &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.fallback_pref.email &&
                                                <img onClick={() => this._setFallbackPref("email")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.email && this.state.edit_profile && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setFallbackPref("email")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.email && this.state.edit_profile && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setFallbackPref("email")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.email && this.state.edit_profile && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setFallbackPref("email")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.email && !this.state.edit_profile &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setFallbackPref("email")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_32")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.fallback_pref.phone &&
                                                <img onClick={() => this._setFallbackPref("phone")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.phone && this.state.edit_profile && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setFallbackPref("phone")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.phone && this.state.edit_profile && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setFallbackPref("phone")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.phone && this.state.edit_profile && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setFallbackPref("phone")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.fallback_pref.phone && !this.state.edit_profile &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setFallbackPref("phone")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_33")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_4")}
                                    </div>
                                    {
                                        !this.state.edit_password &&
                                        <div onClick={() => this.setState({edit_password: true})}
                                             className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_password &&
                                        <div onClick={() => this._changePassword()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_password &&
                                        <div onClick={() => this.setState({edit_password: true})}
                                             className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_password &&
                                        <div onClick={() => this._changePassword()}
                                             className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_password
                                                    })
                                            } onChange={(event) => this.setState({old_password: event.target.value})}
                                            readOnly={!this.state.edit_password} value={this.state.old_password}
                                            type={"password"} placeholder={this._renderText("item_16")}/>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_password
                                                    })
                                            } onChange={(event) => this.setState({password: event.target.value})}
                                            readOnly={!this.state.edit_password} value={this.state.password}
                                            type={"password"} placeholder={this._renderText("item_13")}/>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                            className={
                                                cx(Styles.input,
                                                    {
                                                        [Styles.inputDisabled]: !this.state.edit_password
                                                    })
                                            }
                                            onChange={(event) => this.setState({confirm_password: event.target.value})}
                                            readOnly={!this.state.edit_password} value={this.state.confirm_password}
                                            type={"password"} placeholder={this._renderText("item_14")}/>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.branding && this.state.inhouse &&
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_26")}
                                        </div>
                                        {
                                            !this.state.edit_branding &&
                                            <div onClick={() => this.setState({edit_branding: true})}
                                                 className={Styles.contentInnerItemHeaderEdit}>
                                                {this._renderText("item_3")}
                                            </div>
                                        }
                                        {
                                            this.state.edit_branding &&
                                            <div onClick={() => this._changeBranding()} className={
                                                cx(Styles.contentInnerItemHeaderEdit,
                                                    {
                                                        [Styles.contentInnerItemHeaderEditActive]: true
                                                    })
                                            }>
                                                {this._renderText("item_15")}
                                            </div>
                                        }
                                        {
                                            !this.state.edit_branding &&
                                            <div onClick={() => this.setState({edit_branding: true})}
                                                 className={Styles.contentInnerItemHeaderEditMobile}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        }
                                        {
                                            this.state.edit_branding &&
                                            <div onClick={() => this._changeBranding()}
                                                 className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_branding
                                                        })
                                                } onChange={(event) => {
                                                this.state.branding_pref.primary_color = event.target.value;
                                                this.setState({branding_pref: this.state.branding_pref})
                                            }} readOnly={!this.state.edit_branding}
                                                value={this.state.branding_pref.primary_color}
                                                placeholder={this._renderText("item_27")}/>
                                            <div
                                                style={this.state.branding_pref.primary_color ? {backgroundColor: this.state.branding_pref.primary_color} : {}}
                                                className={Styles.colorContainerIcon}></div>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_branding
                                                        })
                                                } onChange={(event) => {
                                                this.state.branding_pref.secondary_color = event.target.value;
                                                this.setState({branding_pref: this.state.branding_pref})
                                            }} readOnly={!this.state.edit_branding}
                                                value={this.state.branding_pref.secondary_color}
                                                placeholder={this._renderText("item_28")}/>
                                            <div
                                                style={this.state.branding_pref.secondary_color ? {backgroundColor: this.state.branding_pref.secondary_color} : {}}
                                                className={Styles.colorContainerIcon}></div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDivider}>
                                            {this._renderBrandingImage()}
                                            <div className={Styles.inputDividerFaviconDesktop}>
                                                {this._renderBrandingFaviconImage()}
                                            </div>
                                            <div className={Styles.inputDividerFacebookData}>
                                                Facebook page ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.facebook_id}</span>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>Instagram actor ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.instagram_id}</span></div>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>TikTok account ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.tiktok_id}</span></div>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>Snapchat user ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.snapchat_id}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerFaviconMobile}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDivider}>
                                                {this._renderBrandingFaviconImage()}
                                            </div>
                                            <div className={Styles.inputDividerFacebookDataMobile}>
                                                Facebook page ID <span className={Styles.inputDividerFacebookDataBoldMobile}>{this.state.facebook_id}</span>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>Instagram actor ID <span className={Styles.inputDividerFacebookDataBoldMobile}>{this.state.instagram_id}</span></div>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>TikTok account ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.tiktok_id}</span></div>
                                                <div style={{paddingTop: 'calc(var(--size-factor) * 10px)'}}>Snapchat user ID <span className={Styles.inputDividerFacebookDataBold}>{this.state.snapchat_id}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.branding_pref.disable_infobox &&
                                                    <img onClick={() => this._setThemePref("disable_infobox")}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.disable_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setThemePref("disable_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.disable_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setThemePref("disable_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.disable_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setThemePref("disable_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.disable_infobox && !this.state.edit_branding &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setThemePref("disable_infobox")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_41")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.branding_pref.opacity_infobox &&
                                                    <img onClick={() => this._setThemePref("opacity_infobox")}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.opacity_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setThemePref("opacity_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.opacity_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setThemePref("opacity_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.opacity_infobox && this.state.edit_branding && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setThemePref("opacity_infobox")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.opacity_infobox && !this.state.edit_branding &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setThemePref("opacity_infobox")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_44")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.branding_pref.infobox_m &&
                                                    <img onClick={() => {
                                                        this._setThemePref("infobox_m");
                                                        if (this.state.branding_pref.infobox_s) {
                                                            this._setThemePref("infobox_s");
                                                        }
                                                        if (this.state.branding_pref.infobox_xs) {
                                                            //activate if extra setings
                                                            //this._setThemePref("infobox_xs");
                                                        }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_m && this.state.edit_branding && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setThemePref("infobox_m")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_m && this.state.edit_branding && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setThemePref("infobox_m")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_m && this.state.edit_branding && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setThemePref("infobox_m")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_m && !this.state.edit_branding &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setThemePref("infobox_m")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_43")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.branding_pref.infobox_s &&
                                                    <img onClick={() => {
                                                        this._setThemePref("infobox_s");
                                                        if (this.state.branding_pref.infobox_m) {
                                                            this._setThemePref("infobox_m");
                                                        }
                                                        if (this.state.branding_pref.infobox_xs) {
                                                            //activate if extra setings
                                                            //this._setThemePref("infobox_xs");
                                                        }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_s && this.state.edit_branding && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setThemePref("infobox_s")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_s && this.state.edit_branding && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setThemePref("infobox_s")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_s && this.state.edit_branding && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setThemePref("infobox_s")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_s && !this.state.edit_branding &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setThemePref("infobox_s")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_42")}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            false &&
                                            //extra settings
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.branding_pref.infobox_xs &&
                                                    <img onClick={() => {
                                                        this._setThemePref("infobox_xs");
                                                        if (this.state.branding_pref.infobox_s) {
                                                            this._setThemePref("infobox_s");
                                                        }
                                                        if (this.state.branding_pref.infobox_m) {
                                                            this._setThemePref("infobox_m");
                                                        }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_xs && this.state.edit_branding && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setThemePref("infobox_xs")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_xs && this.state.edit_branding && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setThemePref("infobox_xs")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_xs && this.state.edit_branding && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setThemePref("infobox_xs")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.branding_pref.infobox_xs && !this.state.edit_branding &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setThemePref("infobox_xs")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_44")}
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.branding && this.state.inhouse && this.state.edit_branding &&
                                <div className={Styles.arrowDown}>
                                    <img className={Styles.arrowDownItem}
                                         src={require('../../assets/images/pb_arrow_down.png')}/>
                                </div>
                            }
                            {
                                this.state.branding && this.state.inhouse && this.state.edit_branding &&
                                <div className={Styles.brandContainerPreview}>
                                    <div className={Styles.brandContainerPreviewLeft}>
                                        <div className={Styles.brandContainerPreviewLeftFacebook}>
                                            <div className={Styles.brandContainerPreviewLeftFacebookItem}>
                                            {
                                                this.state.account && this.state.account.logo_image &&
                                                <img className={Styles.brandContainerPreviewLeftFacebookLogo} src={this.state.account.logo_image}/>
                                            }
                                            <svg xmlns="http://www.w3.org/2000/svg" width="300px" height="157px" viewBox="0 0 300 157">
                                                <rect fill="#FFFFFF" width="300" height="157"/>
                                                <rect fill="#E6E6E6" width="180" height="157"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" d="M47.05,39.499c0,6.903-5.596,12.5-12.5,12.5
                                                c-6.903,0-12.5-5.597-12.5-12.5s5.597-12.5,12.5-12.5C41.454,26.999,47.05,32.596,47.05,39.499"/>
                                                <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="27.478,156.994 63.932,102.996 96.329,156.997 "/>
                                                <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="65.284,156.994 119.271,76.502 175.055,157.003 "/>
                                                {
                                                    !this.state.branding_pref.disable_infobox &&
                                                <rect opacity={this.state.branding_pref.opacity_infobox ? "0.7" : ""} x="0.5" y="19" fill={this.state.branding_pref.primary_color} width={this.state.branding_pref.infobox_s ? (142.5 * 0.8).toString() : this.state.branding_pref.infobox_m ? (142.5 * 0.9).toString() : "142.5"} height={this.state.branding_pref.infobox_s ? (25 * 0.8).toString() : this.state.branding_pref.infobox_m ? (25 * 0.9).toString() : "25"}/>
                                                }
                                                {
                                                    !this.state.branding_pref.disable_infobox &&
                                                <rect opacity={this.state.branding_pref.opacity_infobox ? "0.7" : ""} x={this.state.branding_pref.infobox_s ? (75.5 * 0.8).toString() : this.state.branding_pref.infobox_m ? (75.5 * 0.9).toString() : "75.5"} y={this.state.branding_pref.infobox_s ? (44 * 0.89).toString() : this.state.branding_pref.infobox_m ? (44 * 0.95).toString() : "44"} fill={this.state.branding_pref.secondary_color} width={this.state.branding_pref.infobox_s ? (67.5 * 0.8).toString() : this.state.branding_pref.infobox_m ? (67.5 * 0.9).toString() : "67.5"} height={this.state.branding_pref.infobox_s ? (12.5 * 0.8).toString() : this.state.branding_pref.infobox_m ? (12.5 * 0.9).toString() : "12.5"}/>
                                                }
                                                <line fill="none" stroke={this.state.branding_pref.secondary_color} stroke-width="5" stroke-miterlimit="10" x1="202.5" y1="116.836" x2="277.5" y2="116.836"/>
                                                <line fill="none" stroke={this.state.branding_pref.secondary_color} stroke-width="5" stroke-miterlimit="10" x1="215" y1="127.836" x2="265" y2="127.836"/>
                                            </svg>
                                            </div>
                                        </div>
                                        <div className={Styles.brandContainerPreviewLeftInstagram}>
                                            <div className={Styles.brandContainerPreviewLeftInstagramItem}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="300px" height="300px" viewBox="0 0 300 300">
                                                <rect fill="#FFFFFF" width="300" height="300"/>
                                                <rect fill="#E6E6E6" width="300" height="203"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" d="M74.5,63.75c0,10.355-8.395,18.75-18.75,18.75S37,74.105,37,63.75
                                                S45.395,45,55.75,45S74.5,53.395,74.5,63.75"/>
                                                <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="47.586,203.096 107.25,116.095 161.55,203.099 "/>
                                                <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="110.647,203.102 198.647,74.098 292.065,203.101 "/>
                                                {
                                                    !this.state.branding_pref.disable_infobox &&
                                                <rect opacity={this.state.branding_pref.opacity_infobox ? "0.7" : ""} y="26" fill={this.state.branding_pref.primary_color} width={this.state.branding_pref.infobox_s ? (235.001 * 0.7).toString() : this.state.branding_pref.infobox_m ? (235.001 * 0.85).toString() : "235.001"} height={this.state.branding_pref.infobox_s ? (40 * 0.7).toString() : this.state.branding_pref.infobox_m ? (40 * 0.85).toString() : "40"}/>
                                                }
                                                {
                                                    !this.state.branding_pref.disable_infobox &&
                                                    <rect opacity={this.state.branding_pref.opacity_infobox ? "0.7" : ""} x={this.state.branding_pref.infobox_s ? (135 * 0.7).toString() : this.state.branding_pref.infobox_m ? (135 * 0.85).toString() : "135"} y={this.state.branding_pref.infobox_s ? (66 * 0.82).toString() : this.state.branding_pref.infobox_m ? (66 * 0.91).toString() : "66"} fill={this.state.branding_pref.secondary_color} width={this.state.branding_pref.infobox_s ? (100 * 0.7).toString() : this.state.branding_pref.infobox_m ? (100 * 0.85).toString() : "100"} height={this.state.branding_pref.infobox_s ? (17.5 * 0.7).toString() : this.state.branding_pref.infobox_m ? (17.5 * 0.85).toString() : "17.5"}/>
                                                }
                                                </svg>
                                            {
                                                this.state.account && this.state.account.branding_image &&
                                                <img className={Styles.brandContainerPreviewLeftInstagramLogo} src={this.state.account.branding_image}/>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.brandContainerPreviewRight}>
                                        <div className={Styles.brandContainerPreviewRightImage}>
                                            <div className={Styles.brandContainerPreviewRightImageItem}>
                                            {
                                                this.state.account && this.state.account.logo_image &&
                                                <img className={Styles.brandContainerPreviewRightImageItemLogo} src={this.state.account.logo_image}/>
                                            }
                                                <svg xmlns="http://www.w3.org/2000/svg" width="495px" height="100%" viewBox="0 0 1800 2176">
                                            <rect fill="#FFFFFF" width="1800" height="2176"/>
                                            <rect fill="#FFFFFF" width="1800" height="410"/>
                                            <g>
                                                <path d="M581.625,318.333h-7.865v-10.335h20.151V356.1h-12.286V318.333z"/>
                                            </g>
                                            <g>
                                                <path d="M631.61,307.998h17.681c4.94,0,8.906,1.105,11.636,3.25c2.795,2.08,4.29,5.265,4.29,9.36c0,3.705-1.69,7.475-5.59,9.685
                                                    c7.735,2.73,7.931,9.166,7.931,11.181c0,3.835-1.495,8.06-4.42,10.465c-4.42,3.705-7.605,4.16-15.73,4.16H631.61V307.998z
                                                     M643.896,326.264h4.355c0.845,0,2.145,0,3.25-0.455c1.105-0.52,1.95-1.495,1.95-3.38c0-1.82-0.845-2.73-1.885-3.185
                                                    s-2.34-0.455-3.315-0.455h-4.355V326.264z M643.896,345.31h5.785c0.78,0,2.34,0,3.64-0.585c1.365-0.585,2.47-1.755,2.47-4.03
                                                    c0-2.08-1.04-3.12-2.34-3.64c-1.235-0.52-2.795-0.52-3.77-0.52h-5.785V345.31z"/>
                                            </g>
                                            <g>
                                                <path d="M673.665,307.998h27.236v10.791h-14.951v7.476h14.496v10.79h-14.496v8.255h14.951V356.1h-27.236V307.998z"/>
                                            </g>
                                            <g>
                                                <path d="M707.985,307.998h15.926c5.395,0,15.016,0,21.256,8.971c3.315,4.55,4.42,9.685,4.42,14.95
                                                    c0,13.131-6.5,24.181-24.766,24.181h-16.836V307.998z M720.271,345.31h5.265c9.166,0,11.766-6.37,11.766-13.195
                                                    c0-2.73-0.585-6.175-2.34-8.905c-1.43-2.145-3.9-4.42-9.36-4.42h-5.33V345.31z"/>
                                            </g>
                                            <g>
                                                <path d="M776.3,307.998h26.261v10.791h-13.976v8.19h13.456v10.791h-13.456V356.1H776.3V307.998z"/>
                                            </g>
                                            <g>
                                                <path d="M807.11,332.569c0-15.73,12.091-25.481,25.351-25.481c14.821,0,25.416,11.57,25.416,24.961
                                                    c0,13.39-10.53,24.961-25.481,24.961c-15.146,0-25.286-12.025-25.286-24.376V332.569z M819.396,331.984
                                                    c0,7.345,5.005,14.235,13.261,14.235c8.71,0,12.935-7.93,12.935-14.105c0-6.24-4.225-14.235-13.065-14.235
                                                    c-8.515,0-13.13,7.28-13.13,14.04V331.984z"/>
                                            </g>
                                            <g>
                                                <path d="M864.504,307.998h15.731c7.54,0,12.22,1.365,14.885,3.445c4.03,3.12,5.85,7.865,5.85,13.13c0,3.706-1.04,6.565-2.405,8.71
                                                    c-1.625,2.535-3.965,4.16-6.24,5.135l9.946,17.681h-12.676l-12.546-23.206h2.015c3.12,0,5.786-0.26,7.411-1.3
                                                    c1.495-0.975,2.73-3.25,2.73-5.916c0-2.535-1.235-4.55-2.86-5.59c-1.365-0.845-3.315-1.3-5.005-1.3h-4.55V356.1h-12.286V307.998z"
                                                    />
                                            </g>
                                            <g>
                                                <path d="M936.525,340.174c0,5.59,3.445,6.565,5.006,6.565c2.925,0,4.68-2.405,4.68-4.615c0-2.535-2.016-3.315-9.426-6.435
                                                    c-3.379-1.365-11.765-4.745-11.765-13.781c0-9.685,8.774-14.82,16.835-14.82c6.631,0,15.991,3.38,16.186,14.951h-12.154
                                                    c-0.261-1.625-0.65-4.681-4.421-4.681c-2.146,0-4.226,1.495-4.226,3.771c0,2.21,1.301,2.795,9.945,6.695
                                                    c8.971,4.03,11.246,8.19,11.246,13.78c0,7.67-4.03,15.406-16.771,15.406c-12.61,0-17.681-7.411-17.356-16.836H936.525z"/>
                                            </g>
                                            <g>
                                                <path d="M973.836,356.1H960.51l19.046-48.102h10.595l18.461,48.102h-13.455l-2.275-6.955h-16.836L973.836,356.1z M984.301,322.624
                                                    l-5.2,16.771h10.595L984.301,322.624z"/>
                                            </g>
                                            <g>
                                                <path d="M1013.875,307.998h12.285v37.312h14.235V356.1h-26.521V307.998z"/>
                                            </g>
                                            <g>
                                                <path d="M1045.205,307.998h27.236v10.791h-14.951v7.476h14.496v10.79h-14.496v8.255h14.951V356.1h-27.236V307.998z"/>
                                            </g>
                                            <rect x="567" y="1084" fill="#F2F2F2" width="1100" height="265"/>
                                            <rect x="567" y="1348" fill="#FCFCFC" width="1100" height="675"/>
                                            <line fill="none" stroke={this.state.branding_pref.secondary_color} stroke-width={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "5" : "10"} stroke-miterlimit="10" x1="1667" y1="1347.5" x2="120" y2="1347.5"/>
                                            <rect x="569" y="251" fill={this.state.branding_pref.secondary_color} width="592" height="24"/>
                                            <rect x="572" y="307" width="500" height="52"/>
                                            <rect x="1110" y="314" width="500" height="40"/>
                                            <rect x="615" y="1161" width="337.4" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="615" y="1211" width="152.6" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="615" y="1260" width="282" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="1312.2" y="1161" width="314.2" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="1513.8" y="1211" width="112.601" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="1439.4" y="1261" width="187" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect y="2022" width="1800" height="154"/>
                                            <polyline fill="none" stroke={this.state.branding_pref.primary_color} stroke-width="2" stroke-miterlimit="10" points="0,2097 1258,2097 1258,2020.5 "/>
                                            <rect x="567" y="410" fill="#E6E6E6" width="1100" height="674.973"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" d="M838.749,594.578c0,37.832-30.668,68.5-68.5,68.5
                                                s-68.5-30.668-68.5-68.5s30.668-68.5,68.5-68.5S838.749,556.747,838.749,594.578"/>
                                            <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="734.665,1085.014 957.455,852.849 1155.412,1085.01 "/>
                                            <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="965.676,1085.01 1295.625,738.929 1636.5,1085.021 "/>
                                            <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#F2F2F2" points="1142.137,1342.281 1116.762,1367.656 1091.388,1342.281
                                                1116.763,1316.906 "/>
                                            <rect x="90" y="2125" fill="#808080" width="533" height="20"/>
                                            <rect x="210" y="1625" fill="#CCCCCC" width="211" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <rect x="242" y="1664" fill="#CCCCCC" width="148" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "20" : "24"}/>
                                            <polyline fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.secondary_color} points={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "1117.361,1375.333 1088.031,1346.03 1094.476,1345.352 1116.904,1367.607 1139.257,1345.257 1146.236,1345.931" : "1117.361,1380.338 1085.542,1348.52 1091.68,1342.382 1116.904,1367.607 1141.915,1342.6 1148.772,1348.467"} />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1652.5,54h65c12.427,0,22.5,10.073,22.5,22.5S1729.927,99,1717.5,99h-130
                                                c-12.427,0-22.5-10.073-22.5-22.5s10.073-22.5,22.5-22.5"/>
                                            <rect x="115" y="410" fill="#FFFFFF" width="450" height="675"/>
                                            <rect x="115" y="410" fill="#F7F7F7" width="450" height="155"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.primary_color} d="M369,1084.5c0,15.188-12.312,27.5-27.5,27.5
                                                s-27.5-12.312-27.5-27.5s12.312-27.5,27.5-27.5S369,1069.312,369,1084.5"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.primary_color} d="M301,1084.5c0,15.188-12.312,27.5-27.5,27.5
                                                s-27.5-12.312-27.5-27.5s12.312-27.5,27.5-27.5S301,1069.312,301,1084.5"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.primary_color} d="M436,1084.5c0,15.188-12.312,27.5-27.5,27.5
                                                s-27.5-12.312-27.5-27.5s12.312-27.5,27.5-27.5S436,1069.312,436,1084.5"/>
                                            <rect x="236" y="483" fill={this.state.branding_pref.primary_color} width="220" height="35"/>
                                            <rect x="236" y="457" fill="#999999" width="80" height="15"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill="#ECECEC" d="M437,712c0,56.333-45.667,102-102,102s-102-45.667-102-102
                                                s45.667-102,102-102S437,655.667,437,712"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill="#C6C6C6" d="M311.2,760.853c-5.024-2.73-9.665-6.273-13.739-10.549
                                                c-10.413-10.931-16.264-25.757-16.264-41.216c0-15.458,5.851-30.285,16.264-41.216c10.413-10.931,24.538-17.072,39.264-17.072
                                                c14.727,0,28.852,6.141,39.265,17.072c10.413,10.931,16.263,25.758,16.263,41.216c0,15.459-5.85,30.285-16.263,41.216
                                                c-3.783,3.97-8.055,7.31-12.667,9.95l25.456,38.418C372.759,808.611,354.157,814,335,814c-17.352,0-34.25-4.422-49.184-12.641"/>
                                            <rect x="164" y="863" fill="#999999" width="180" height="17"/>
                                            <rect x="164" y="898" width="262" height="17"/>
                                            <rect x="164" y="935" fill="#999999" width="290" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "12" : "15"}/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.primary_color} d="M1116.929,1672.071c1.875,1.875,4.419,2.929,7.071,2.929
                                                s5.196-1.054,7.071-2.929s2.929-4.419,2.929-7.071s-1.054-5.196-2.929-7.071S1126.652,1655,1124,1655s-5.196,1.054-7.071,2.929
                                                S1114,1662.348,1114,1665S1115.054,1670.196,1116.929,1672.071 M1124.389,1702.333c-7.293,0-15.177-13.229-20.334-18.388
                                                c-5.158-5.157-8.055-12.152-8.055-19.445s2.896-14.288,8.055-19.445c5.157-5.158,12.152-8.055,19.445-8.055
                                                s14.288,2.896,19.445,8.055c5.158,5.157,8.055,12.152,8.055,19.445s-2.896,14.288-8.055,19.445
                                                C1137.788,1689.104,1131.682,1702.333,1124.389,1702.333z"/>
                                            </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.brandContainerPreviewMobileLandingPage}>
                                        <div className={Styles.brandContainerPreviewMobileLandingPageImage}>
                                            <div className={Styles.brandContainerPreviewMobileLandingPageImageItem}>
                                                {
                                                    this.state.account && this.state.account.favicon_image &&
                                                    <img className={Styles.brandContainerPreviewMobileLandingPageImageItemLogo} src={this.state.account.favicon_image}/>
                                                }
                                                <svg xmlns="http://www.w3.org/2000/svg" width="300px" height="100%" viewBox="0 0 500 3011">
                                                    <rect fill="#FFFFFF" width="500" height="3011"/>
                                                    <rect fill="#FFFFFF" width="500" height="850"/>
                                                    <line fill="none" stroke="#000000" stroke-width="4" stroke-miterlimit="10" x1="420" y1="36" x2="455" y2="36"/>
                                                    <line fill="none" stroke="#000000" stroke-width="4" stroke-miterlimit="10" x1="420" y1="48" x2="455" y2="48"/>
                                                    <line fill="none" stroke="#000000" stroke-width="4" stroke-miterlimit="10" x1="420" y1="60" x2="455" y2="60"/>
                                                    <rect y="953" fill="#F2F2F2" width="500" height="250"/>
                                                    <rect y="1207.5" fill="#FCFCFC" width="500" height="250"/>
                                                    <line fill="none" stroke={this.state.branding_pref.secondary_color} stroke-width={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "5" : "10"} stroke-miterlimit="10" x1="500" y1="1208" x2="0" y2="1208"/>
                                                    <rect y="1458" fill="#FFFFFF" width="500" height="490"/>
                                                    <rect y="1936" fill={this.state.branding_pref.primary_color} width="166" height="50"/>
                                                    <rect x="166" y="1936" fill={this.state.branding_pref.primary_color} width="166" height="50"/>
                                                    <rect x="332" y="1936" fill={this.state.branding_pref.primary_color} width="166" height="50"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.secondary_color} d="M279,154.5c0,15.188-12.312,27.5-27.5,27.5S224,169.688,224,154.5
                                                    s12.312-27.5,27.5-27.5S279,139.312,279,154.5"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.secondary_color} d="M211,154.5c0,15.188-12.312,27.5-27.5,27.5S156,169.688,156,154.5
                                                    s12.312-27.5,27.5-27.5S211,139.312,211,154.5"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.secondary_color} d="M346,154.5c0,15.188-12.312,27.5-27.5,27.5S291,169.688,291,154.5
                                                    s12.312-27.5,27.5-27.5S346,139.312,346,154.5"/>
                                                    <rect y="530" fill="#E6E6E6" width="499.997" height="423.984"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" d="M132.249,622.733c0,19.606-15.894,35.5-35.5,35.5
                                                    s-35.5-15.894-35.5-35.5s15.894-35.5,35.5-35.5S132.249,603.127,132.249,622.733"/>
                                                    <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="76.3,954 177.506,839.532 267.494,953.989 "/>
                                                    <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#CCCCCC" points="181.326,954.001 331.211,783.369 486.159,953.993 "/>
                                                    <rect x="82" y="225" fill={this.state.branding_pref.secondary_color} width="334" height="22"/>
                                                    <rect x="194" y="268" fill={this.state.branding_pref.secondary_color} width="110" height="14"/>
                                                    <rect x="60" y="313" width="381.333" height="40"/>
                                                    <rect x="92" y="379.667" width="312" height="28"/>
                                                    <rect y="450" fill="#F7F7F7" width="500" height="80"/>
                                                    <rect x="445" y="450" fill="#FFFFFF" width="55" height="210"/>
                                                    <rect x="143" y="476" fill={this.state.branding_pref.primary_color} width="213" height="25"/>
                                                    <rect x="35" y="1028" width="298" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect x="35" y="1073" width="136.857" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect x="35" y="1118" width="249" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect y="2116" fill="#F2F2F2" width="500" height="600"/>
                                                    <rect y="2716" width="500" height="295"/>
                                                    <line fill="none" stroke={this.state.branding_pref.primary_color} stroke-width="2" stroke-miterlimit="10" x1="0" y1="2860" x2="500" y2="2860"/>
                                                    <rect x="188" y="1284" width="274" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect x="366" y="1329" width="96" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect x="300" y="1374" width="162" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#ECECEC" d="M350,1663c0,56.333-45.667,102-102,102s-102-45.667-102-102
                                                    s45.667-102,102-102S350,1606.667,350,1663"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#C6C6C6" d="M224.2,1711.854c-5.024-2.73-9.665-6.273-13.739-10.55
                                                    c-10.413-10.931-16.264-25.757-16.264-41.216c0-15.458,5.851-30.285,16.264-41.216s24.538-17.072,39.264-17.072
                                                    c14.728,0,28.853,6.142,39.266,17.072s16.263,25.758,16.263,41.216c0,15.459-5.85,30.285-16.263,41.216
                                                    c-3.783,3.971-8.055,7.31-12.667,9.95l25.456,38.418C285.759,1759.611,267.157,1765,248,1765c-17.352,0-34.25-4.422-49.184-12.641"
                                                    />
                                                    <line fill="none" stroke={this.state.branding_pref.secondary_color} stroke-width={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "5" : "10"} stroke-miterlimit="10" x1="500" y1="1469.334" x2="0" y2="1469.334"/>
                                                    <polyline fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" points="273.635,1464.559 248.365,1489.828 223.096,1464.559
                                                    248.365,1439.29 "/>
                                                    <polyline fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.secondary_color} points={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "248.625,1497.167 219.304,1467.929 226.457,1467.92 248.204,1489.482 270.516,1467.689 277.696,1467.677" : "248.625,1502.246 216.806,1470.427 222.978,1464.255 248.204,1489.482 273.353,1464.275 280.216,1470.198"}/>
                                                    <rect x="93" y="2045" fill="#CCCCCC" width="314" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "16" : "20"}/>
                                                    <rect x="114" y="2911" fill="#808080" width="278.6" height="16"/>
                                                    <rect x="132.8" y="2935" fill="#808080" width="244.2" height="16"/>
                                                    <rect x="156" y="1809" fill="#999999" width="180" height="17"/>
                                                    <rect x="90" y="1842" width="296" height="19"/>
                                                    <rect x="52" y="1879" fill="#999999" width="370" height={this.state.branding_pref.infobox_m || this.state.branding_pref.infobox_s ? "14" : "17"}/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" fill={this.state.branding_pref.primary_color} d="M258.929,2400.071c1.875,1.875,4.419,2.929,7.071,2.929
                                                    s5.196-1.054,7.071-2.929S276,2395.652,276,2393s-1.054-5.196-2.929-7.071S268.652,2383,266,2383s-5.196,1.054-7.071,2.929
                                                    S256,2390.348,256,2393S257.054,2398.196,258.929,2400.071 M266.389,2430.333c-7.293,0-15.177-13.229-20.334-18.388
                                                    c-5.158-5.157-8.055-12.152-8.055-19.445s2.896-14.288,8.055-19.445c5.157-5.158,12.152-8.055,19.445-8.055
                                                    s14.288,2.896,19.445,8.055c5.158,5.157,8.055,12.152,8.055,19.445s-2.896,14.288-8.055,19.445
                                                    C279.788,2417.104,273.682,2430.333,266.389,2430.333z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.branding_pref && this.state.branding_pref.primary_color &&
                                <div className={Styles.contentInnerItem}>
                                    <div className={Styles.contentInnerItemHeader}>
                                        <div className={Styles.contentInnerItemHeaderTitle}>
                                            {this._renderText("item_34")}
                                        </div>
                                        {
                                            !this.state.edit_lead &&
                                            <div onClick={() => this.setState({edit_lead: true})}
                                                 className={Styles.contentInnerItemHeaderEdit}>
                                                {this._renderText("item_3")}
                                            </div>
                                        }
                                        {
                                            this.state.edit_lead &&
                                            <div onClick={() => this._changeAccount()} className={
                                                cx(Styles.contentInnerItemHeaderEdit,
                                                    {
                                                        [Styles.contentInnerItemHeaderEditActive]: true
                                                    })
                                            }>
                                                {this._renderText("item_15")}
                                            </div>
                                        }
                                        {
                                            !this.state.edit_lead &&
                                            <div onClick={() => this.setState({edit_lead: true})}
                                                 className={Styles.contentInnerItemHeaderEditMobile}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        }
                                        {
                                            this.state.edit_lead &&
                                            <div onClick={() => this._changeAccount()}
                                                 className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.lead_pref.consider &&
                                                    <img onClick={() => this._setLeadPref("consider")}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.consider && this.state.edit_lead && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setLeadPref("consider")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.consider && this.state.edit_lead && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setLeadPref("consider")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.consider && this.state.edit_lead && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setLeadPref("consider")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.consider && !this.state.edit_lead &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setLeadPref("consider")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_35")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.lead_pref.unqualified_phone_email &&
                                                    <img onClick={() => {
                                                        this._setLeadPref("unqualified_phone_email");
                                                        if (this.state.lead_pref.unqualified_phone) {
                                                            this._setLeadPref("unqualified_phone");
                                                        }
                                                        if (this.state.lead_pref.unqualified) {
                                                            this._setLeadPref("unqualified");
                                                        }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone_email && this.state.edit_lead && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone_email")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone_email && this.state.edit_lead && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone_email")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone_email && this.state.edit_lead && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone_email")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone_email && !this.state.edit_lead &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setLeadPref("unqualified_phone_email")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_36")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.lead_pref.unqualified_phone &&
                                                    <img onClick={() => {
                                                        this._setLeadPref("unqualified_phone");
                                                        if (this.state.lead_pref.unqualified_phone_email) {
                                                        this._setLeadPref("unqualified_phone_email");
                                                        }
                                                        if (this.state.lead_pref.unqualified) {
                                                        this._setLeadPref("unqualified");
                                                        }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone && this.state.edit_lead && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone && this.state.edit_lead && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone && this.state.edit_lead && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setLeadPref("unqualified_phone")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified_phone && !this.state.edit_lead &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setLeadPref("unqualified_phone")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_37")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={Styles.inputDividerItem}>
                                            <div className={Styles.inputDividerItemCheckmark}>
                                                {
                                                    !this.state.lead_pref.unqualified &&
                                                    <img onClick={() => {
                                                            this._setLeadPref("unqualified");
                                                            if (this.state.lead_pref.unqualified_phone) {
                                                            this._setLeadPref("unqualified_phone");
                                                            }
                                                            if (this.state.lead_pref.unqualified_phone_email) {
                                                            this._setLeadPref("unqualified_phone_email");
                                                            }
                                                    }}
                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified && this.state.edit_lead && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img onClick={() => this._setLeadPref("unqualified")}
                                                         src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified && this.state.edit_lead && salesChannelRegister.get("name") === "yieldlock" &&
                                                    <img onClick={() => this._setLeadPref("unqualified")}
                                                         src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified && this.state.edit_lead && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img onClick={() => this._setLeadPref("unqualified")}
                                                         src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                         className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                {
                                                    this.state.lead_pref.unqualified && !this.state.edit_lead &&
                                                    <img
                                                        src={require("../../assets/images/checkmark-disabled.svg")}
                                                        className={Styles.inputDividerItemCheckmarkIcon}/>
                                                }
                                                <div onClick={() => this._setLeadPref("unqualified")}
                                                     className={Styles.inputDividerItemCheckmarkText}>
                                                    {this._renderText("item_38")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_lead
                                                        })
                                                } onChange={(event) => {
                                                    this.state.lead_pref.excluded_email = event.target.value.toLowerCase();
                                                    this.setState({lead_pref: this.state.lead_pref})
                                            }} readOnly={!this.state.edit_lead}
                                                value={this.state.lead_pref.excluded_email}
                                                placeholder={this._renderText("item_39")}/>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_lead
                                                        })
                                                } onChange={(event) => {
                                                this.state.lead_pref.cc_email_1 = event.target.value.toLowerCase();
                                                this.setState({lead_pref: this.state.lead_pref})
                                            }} readOnly={!this.state.edit_lead}
                                                value={this.state.lead_pref.cc_email_1}
                                                placeholder={this._renderText("item_40")}/>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={Styles.inputDividerItem}>
                                            <input
                                                style={salesChannelRegister.get('name') === 'yieldlock' ? {color: '#00273A'} : {}}
                                                className={
                                                    cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.edit_lead
                                                        })
                                                } onChange={(event) => {
                                                this.state.lead_pref.cc_email_2 = event.target.value.toLowerCase();
                                                this.setState({lead_pref: this.state.lead_pref})
                                            }} readOnly={!this.state.edit_lead}
                                                value={this.state.lead_pref.cc_email_2}
                                                placeholder={this._renderText("item_40")}/>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={Styles.contentInnerItem}>
                                <div className={Styles.contentInnerItemHeader}>
                                    <div className={Styles.contentInnerItemHeaderTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    {
                                        !this.state.edit_email &&
                                        <div onClick={() => this.setState({edit_email: true})}
                                             className={Styles.contentInnerItemHeaderEdit}>
                                            {this._renderText("item_3")}
                                        </div>
                                    }
                                    {
                                        this.state.edit_email &&
                                        <div onClick={() => this._changeAccount()} className={
                                            cx(Styles.contentInnerItemHeaderEdit,
                                                {
                                                    [Styles.contentInnerItemHeaderEditActive]: true
                                                })
                                        }>
                                            {this._renderText("item_15")}
                                        </div>
                                    }
                                    {
                                        !this.state.edit_email &&
                                        <div onClick={() => this.setState({edit_email: true})}
                                             className={Styles.contentInnerItemHeaderEditMobile}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                    {
                                        this.state.edit_email &&
                                        <div onClick={() => this._changeAccount()}
                                             className={cx(Styles.contentInnerItemHeaderEditMobile, Styles.contentInnerItemHeaderEditMobileGreen)}>
                                            <img className={Styles.contentInnerItemHeaderEditMobileIcon}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    }
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.reminders &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && this.state.edit_email && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && this.state.edit_email && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && this.state.edit_email && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setEmailPref("reminders")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.reminders && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("reminders")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_6")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.offers &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && this.state.edit_email && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && this.state.edit_email && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && this.state.edit_email && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setEmailPref("offers")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.offers && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("offers")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_7")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.news &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && this.state.edit_email && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && this.state.edit_email && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && this.state.edit_email && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setEmailPref("news")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.news && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("news")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_8")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.inputDividerItemCheckmark}>
                                            {
                                                !this.state.email_pref.surveys &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && this.state.edit_email && salesChannelRegister.get("name") === "propertybooster" &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && this.state.edit_email && salesChannelRegister.get("name") === "yieldlock" &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && this.state.edit_email && salesChannelRegister.get("name") === "boostabostad" &&
                                                <img onClick={() => this._setEmailPref("surveys")}
                                                     src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                                     className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            {
                                                this.state.email_pref.surveys && !this.state.edit_email &&
                                                <img
                                                    src={require("../../assets/images/checkmark-disabled.svg")}
                                                    className={Styles.inputDividerItemCheckmarkIcon}/>
                                            }
                                            <div onClick={() => this._setEmailPref("surveys")}
                                                 className={Styles.inputDividerItemCheckmarkText}>
                                                {this._renderText("item_9")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userProfile;


// WEBPACK FOOTER //
// ./src/components/user-profile/component.js